import {
  PublicOfferContent,
  PublicOfferInfo,
  PublicOfferInfoTitle,
  PublicOfferTitle,
  Wrapper,
} from "./style";

export const PublicOffer = () => {
  return (
    <Wrapper>
      <PublicOfferTitle>PUBLIC OFFER</PublicOfferTitle>

      <PublicOfferInfo>
        <PublicOfferContent>
          Booking and Travel Services Terms for{" "}
          <a href="https://www.flyashgabat.com" target="_blank" rel="noreferrer">
            www.flyashgabat.com
          </a>
        </PublicOfferContent>

        <PublicOfferContent>
          <strong>Service provider:</strong> Jahankeshde Hyzmat P.E. (Individual
          Enterprise "Jahankeshde Hyzmat")
        </PublicOfferContent>

        <PublicOfferContent>
          <strong>Website:</strong>{" "}
          <a href="https://www.flyashgabat.com" target="_blank" rel="noreferrer">
            https://www.flyashgabat.com
          </a>
        </PublicOfferContent>

        <PublicOfferContent>
          <strong>Version:</strong> 1.0
        </PublicOfferContent>

        <PublicOfferContent>
          <strong>Effective date:</strong> 20.08.2026
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>
          1. General Provisions and Acceptance of the Offer
        </PublicOfferInfoTitle>

        <PublicOfferContent>
          1.1. This document is a public offer made by Individual Enterprise
          "Jahankeshde Hyzmat" (hereinafter the "Company", the "Service
          Provider" or "Jahankeshde Hyzmat P.E.") and sets out the terms
          governing use of{" "}
          <a href="https://www.flyashgabat.com" target="_blank" rel="noreferrer">
            www.flyashgabat.com
          </a>
          , the placement of orders, and the provision of travel, information
          and related services under the FlyAshgabat brand.
        </PublicOfferContent>

        <PublicOfferContent>
          1.2. This Offer applies to orders placed by individuals for personal,
          family, tourism and other purposes unrelated to business activity.
          Services for legal entities and individual entrepreneurs are governed
          by a separate corporate or agency agreement.
        </PublicOfferContent>

        <PublicOfferContent>
          1.3. Before confirming an Order, the User must read this Offer in
          full, together with the rules of the selected fare, the Supplier's
          terms and the total price.
        </PublicOfferContent>

        <PublicOfferContent>
          1.4. The User accepts this Offer by completing all actions required
          by the Website interface: confirming agreement with the terms,
          submitting the Order and successfully making payment, or using another
          confirmation method expressly specified by the Company. Acceptance
          forms a contract between the User and the Company on the terms of this
          Offer.
        </PublicOfferContent>

        <PublicOfferContent>
          1.5. The Company's acknowledgement of an Order and the Supplier's
          confirmation of a specific Service are separate stages. A Service is
          considered booked or issued only after the User receives a ticket,
          voucher, itinerary receipt or other confirmation.
        </PublicOfferContent>

        <PublicOfferContent>
          1.6. If any provision of this Offer conflicts with mandatory law, the
          relevant mandatory rule applies and the remaining provisions continue
          in effect.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>2. Definitions</PublicOfferInfoTitle>

        <PublicOfferContent>
          2.1. <strong>Website -</strong> the FlyAshgabat website at{" "}
          <a href="https://www.flyashgabat.com" target="_blank" rel="noreferrer">
            https://www.flyashgabat.com
          </a>
          , including its pages, booking forms and personal account area, where
          available.
        </PublicOfferContent>

        <PublicOfferContent>
          2.2. <strong>User -</strong> a legally capable individual aged 18 or
          over who uses the Website, places an Order for themselves or another
          person, or receives a purchased Service.
        </PublicOfferContent>

        <PublicOfferContent>
          2.3. <strong>Customer -</strong> the User who submits an Order and
          assumes responsibility for payment.
        </PublicOfferContent>

        <PublicOfferContent>
          2.4. <strong>Passenger/Traveller -</strong> a person for whom an air
          ticket, accommodation, transfer, excursion, tour or another Service
          is arranged.
        </PublicOfferContent>

        <PublicOfferContent>
          2.5. <strong>Order -</strong> a request to purchase one or more
          Services submitted through the Website or otherwise confirmed by the
          Company.
        </PublicOfferContent>

        <PublicOfferContent>
          2.6. <strong>Supplier -</strong> an airline, hotel, carrier, booking
          system, tour operator, insurer, transfer provider, excursion provider
          or another independent provider of a Service.
        </PublicOfferContent>

        <PublicOfferContent>
          2.7. <strong>Electronic Ticket -</strong> an electronic record
          confirming a contract of carriage with the relevant carrier; an
          itinerary receipt is normally sent to the User.
        </PublicOfferContent>

        <PublicOfferContent>
          2.8. <strong>Voucher -</strong> an electronic or written confirmation
          of a hotel, transfer, excursion, tour or other ground-service
          booking.
        </PublicOfferContent>

        <PublicOfferContent>
          2.9. <strong>Fare Rules -</strong> the Supplier's conditions governing
          price, baggage, changes, refunds, no-shows, validity and other
          parameters of a Service.
        </PublicOfferContent>

        <PublicOfferContent>
          2.10. <strong>Service Fee -</strong> the Company's fee for search,
          advice, processing, booking, issue, change or refund services; the
          applicable amount is displayed before payment.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>
          3. Role of the Company and Suppliers
        </PublicOfferInfoTitle>

        <PublicOfferContent>
          3.1. For air carriage, accommodation and certain other Services, the
          Company may act as an agent or intermediary by facilitating the
          search, booking, issue, payment, exchange or refund of a Service
          provided by an independent Supplier. In that case, the contract for
          carriage, accommodation or the relevant underlying Service is made
          between the Passenger/Traveller and the applicable Supplier.
        </PublicOfferContent>

        <PublicOfferContent>
          3.2. For travel programmes created or provided by the Company,
          destination management company (DMC) services in Turkmenistan,
          transfers, excursions, guiding and other local services, the Company
          may act as the direct service provider or travel organiser. The
          Company's role and the scope of Services are stated in the offer
          description, during checkout or in the Order confirmation.
        </PublicOfferContent>

        <PublicOfferContent>
          3.3. Each Order is governed by this Offer, the conditions of the
          selected offer, the Fare Rules and the relevant Supplier's terms. The
          User must be given an opportunity to review the applicable conditions
          before payment.
        </PublicOfferContent>

        <PublicOfferContent>
          3.4. The Company is not an air carrier, hotel or public authority and
          does not assume the obligations of such persons, except where an
          obligation is expressly imposed on the Company by law or by a
          confirmed Order.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>4. Placing an Order</PublicOfferInfoTitle>

        <PublicOfferContent>
          4.1. The User places an Order by completing the Website forms or,
          where offered, with assistance from a Company representative. Before
          confirmation, the User must check the itinerary, dates, times,
          airports, passenger details, included Services, Fare Rules and total
          price.
        </PublicOfferContent>

        <PublicOfferContent>
          4.2. Passengers' first and last names must exactly match their travel
          documents and be entered in the format required by the Supplier.
          Correcting a name after issue may be prohibited or may require
          additional payment and reissue.
        </PublicOfferContent>

        <PublicOfferContent>
          4.3. A User placing an Order for another person confirms that they
          are authorised to provide that person's data, accept terms on their
          behalf, and communicate this Offer, the Fare Rules and the travel
          information to them.
        </PublicOfferContent>

        <PublicOfferContent>
          4.4. The User must provide a working telephone number and email
          address, check Company communications regularly and promptly report
          any change to their contact details.
        </PublicOfferContent>

        <PublicOfferContent>
          4.5. Multiple bookings for the same passengers, itinerary and dates
          may be treated by a Supplier as duplicates. In accordance with its
          rules, the Supplier may cancel one or all such bookings.
        </PublicOfferContent>

        <PublicOfferContent>
          4.6. The Company may request information or documents reasonably
          required to verify identity or payment, prevent fraud, or comply with
          Supplier or legal requirements. Issue may be suspended until
          verification is complete.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>
          5. Prices, Fees and Payment
        </PublicOfferInfoTitle>

        <PublicOfferContent>
          5.1. Before payment, the User is shown the total price then available
          for the Order, including the fare, known taxes and charges, and
          separately identified Company fees. Optional Services are not added
          without the User's selection or consent.
        </PublicOfferContent>

        <PublicOfferContent>
          5.2. Fares and availability are supplied by Suppliers and may change
          in real time. A price is not guaranteed until payment succeeds and the
          Supplier confirms issue.
        </PublicOfferContent>

        <PublicOfferContent>
          5.3. If, after payment but before issue, the Supplier does not confirm
          the Service at the selected price, the Company will offer an
          available alternative or request an additional payment. If the User
          declines, the Company will return the amount received for the
          unconfirmed Service through the original payment method, unless
          another method is agreed or required by law.
        </PublicOfferContent>

        <PublicOfferContent>
          5.4. Payment is accepted using the methods and currencies available on
          the Website. A bank, payment system or card issuer may apply its own
          currency conversion, fees and checks; these costs are not a Company
          Service Fee.
        </PublicOfferContent>

        <PublicOfferContent>
          5.5. The Service Fee depends on the Service and is displayed before
          payment. If an Order is cancelled or changed, whether the Service Fee
          is refundable will be determined by the work already performed by the
          Company, costs incurred, the conditions of the Order and mandatory
          law.
        </PublicOfferContent>

        <PublicOfferContent>
          5.6. The User confirms that they are using a lawful payment method
          and are authorised by the account or card holder to make the payment.
          The Company may cancel a suspicious Order and return funds to the
          lawful payer.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>
          6. Confirmation and Delivery of Documents
        </PublicOfferInfoTitle>

        <PublicOfferContent>
          6.1. After successful issue, the Company sends the Electronic Ticket,
          itinerary receipt, Voucher or other confirmation to the email address
          provided by the User or makes it available in the personal account
          area.
        </PublicOfferContent>

        <PublicOfferContent>
          6.2. The User must check all received documents immediately and
          promptly notify the Company of any discrepancy. A failure to report an
          error promptly may result in additional costs or make correction
          impossible.
        </PublicOfferContent>

        <PublicOfferContent>
          6.3. Order processing time depends on the Supplier, payment method,
          any manual verification required and the nature of the Service. Where
          instant issue is unavailable, an estimated time is communicated
          during booking or after the Order is received.
        </PublicOfferContent>

        <PublicOfferContent>
          6.4. Until a confirmation document is received, the User should not
          treat the Service as finally issued or purchase non-refundable related
          services unless the Company has expressly confirmed the Order.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>
          7. Air Tickets and Carriage
        </PublicOfferInfoTitle>

        <PublicOfferContent>
          7.1. Air carriage is governed by the contract between the Passenger
          and the airline, the Fare Rules, the carrier's conditions and
          applicable international and national rules. An Electronic Ticket
          records the carriage arrangements but does not replace the airline's
          applicable conditions.
        </PublicOfferContent>

        <PublicOfferContent>
          7.2. The User must check the terminal, departure time, check-in
          requirements, baggage rules, transit requirements and possible
          schedule changes. The flight should be reconfirmed with the airline
          no later than 24 hours before departure.
        </PublicOfferContent>

        <PublicOfferContent>
          7.3. Failure to board a flight may result in the cancellation of later
          segments and loss of refund entitlement. If a Passenger does not
          intend to use a segment, they should contact the Company or carrier
          in advance.
        </PublicOfferContent>

        <PublicOfferContent>
          7.4. Baggage, seat selection, meals, carriage of animals and special
          assistance are governed by the carrier. Ancillary Services may have
          separate change and refund rules.
        </PublicOfferContent>

        <PublicOfferContent>
          7.5. The Company assists with communications with the carrier but
          does not control schedules, aircraft substitutions, delays,
          cancellations, denied carriage or aviation-security decisions.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>
          8. Hotels, Transfers and Other Stand-Alone Services
        </PublicOfferInfoTitle>

        <PublicOfferContent>
          8.1. Accommodation conditions, check-in and check-out times, meals,
          deposits, resort or city taxes, guest age requirements and
          cancellation rules are set by the hotel or other Supplier and are
          shown in the description or booking confirmation.
        </PublicOfferContent>

        <PublicOfferContent>
          8.2. When booking a transfer, the User must correctly provide the
          date, time, flight number, pick-up point, number of passengers and
          baggage. A material flight delay or itinerary change must be reported
          using the contact details shown on the Voucher.
        </PublicOfferContent>

        <PublicOfferContent>
          8.3. A guest's or passenger's no-show, late arrival or cancellation
          after the stated deadline may result in retention of the full price
          in accordance with the Supplier's terms.
        </PublicOfferContent>

        <PublicOfferContent>
          8.4. Photographs, classifications and property descriptions are
          supplied by Suppliers or based on available information. The Company
          is responsible for the accuracy of its own information to the extent
          required by law, but cannot guarantee that features controlled by the
          Supplier will remain unchanged.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>
          9. Turkmenistan Travel Programmes and DMC Services
        </PublicOfferInfoTitle>

        <PublicOfferContent>
          9.1. The Company may arrange accommodation, meals, transfers,
          excursions, guide services, business and cultural programmes,
          assistance, information support and other travel Services in
          Turkmenistan as specified in the relevant offer.
        </PublicOfferContent>

        <PublicOfferContent>
          9.2. The content, category, duration and price of DMC Services are
          defined by the programme description, quotation, Voucher or individual
          confirmation. Services not expressly stated as included are charged
          separately.
        </PublicOfferContent>

        <PublicOfferContent>
          9.3. The Company may engage suitable local service providers while
          remaining responsible within the scope of its role and mandatory law.
          A material substitution of an agreed Service will be notified to the
          User and, where possible, replaced with an equivalent or higher-standard
          option.
        </PublicOfferContent>

        <PublicOfferContent>
          9.4. Assistance with invitation letters, visa documents or
          registration documents does not guarantee that a visa, entry
          permission or border clearance will be granted. These decisions are
          made by the competent public authorities.
        </PublicOfferContent>

        <PublicOfferContent>
          9.5. Where an Order constitutes a combination of travel Services, the
          Company performs the duties of a travel organiser to the extent
          required by applicable law and the confirmed programme. These terms do
          not restrict any Traveller right that may not lawfully be limited by
          contract.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>
          10. Corporate Travel Services
        </PublicOfferInfoTitle>

        <PublicOfferContent>
          10.1. Website sections describing corporate travel are intended to
          present Services and receive enquiries. Submitting an enquiry does not
          create a credit facility, deferred payment arrangement or other
          special commercial terms.
        </PublicOfferContent>

        <PublicOfferContent>
          10.2. Services for legal entities, public organisations,
          entrepreneurs and professional customers are governed by a separate
          corporate agreement, order form, invoice or other written arrangement.
          If there is a conflict, that specific arrangement prevails over this
          Offer for the relevant corporate Order.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>
          11. Changes, Cancellations and Refunds
        </PublicOfferInfoTitle>

        <PublicOfferContent>
          11.1. The possibility of a change or refund depends on the Fare Rules,
          Supplier terms, nature of the Service and applicable law. Some fares
          and Services may be wholly non-refundable or may not permit changes.
        </PublicOfferContent>

        <PublicOfferContent>
          11.2. A change or refund request must be sent through an available
          Website channel, the personal account area or{" "}
          <a href="mailto:info@flyashgabat.com">info@flyashgabat.com</a>. A
          request is treated as received when the Company acknowledges it; an
          automated delivery message does not necessarily mean that processing
          is complete.
        </PublicOfferContent>

        <PublicOfferContent>
          11.3. For a voluntary cancellation, the refundable amount may be
          reduced by Supplier penalties and charges, costs actually incurred,
          and the Company's Service Fee for work already performed, where those
          deductions were disclosed and are permitted by law.
        </PublicOfferContent>

        <PublicOfferContent>
          11.4. For an involuntary change or cancellation, the Supplier's rules
          and mandatory law apply. The Company informs the User of available
          options after receiving the Supplier's confirmation.
        </PublicOfferContent>

        <PublicOfferContent>
          11.5. Refunds are normally made to the original payment method. The
          time taken for funds to appear depends on the Supplier, payment system
          and bank. The Company initiates a refund within the period required by
          applicable law or, if no period is prescribed, within a reasonable
          time after receiving the necessary funds and documents.
        </PublicOfferContent>

        <PublicOfferContent>
          11.6. Crediting an amount to an internal balance or applying it to a
          new Order is permitted only with the User's express consent and where
          that function is available on the Website.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>
          12. Travel Documents, Visas and Entry Requirements
        </PublicOfferInfoTitle>

        <PublicOfferContent>
          12.1. Each Passenger/Traveller is responsible for holding a valid
          passport, visas, permits, health and transit documents, insurance,
          consent for a minor to travel, and any other documents required by the
          countries of departure, transit and destination.
        </PublicOfferContent>

        <PublicOfferContent>
          12.2. Unless a separate agreement expressly provides a consultation
          Service, Company information about visa, health, customs or
          immigration requirements is for general guidance only. Requirements
          must be verified with the competent public authorities and the
          carrier.
        </PublicOfferContent>

        <PublicOfferContent>
          12.3. A refusal of a visa, entry, boarding or clearance for reasons
          outside the Company's control does not by itself create a refund
          right beyond what is allowed by the Fare Rules, Supplier terms and
          law.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>13. User Responsibilities</PublicOfferInfoTitle>

        <PublicOfferContent>
          13.1. The User must use the Website in good faith, must not disrupt
          its operation, use automated means without permission, create
          fictitious bookings or provide false information.
        </PublicOfferContent>

        <PublicOfferContent>
          13.2. The User must keep personal account credentials confidential
          and promptly notify the Company of suspected unauthorised access.
        </PublicOfferContent>

        <PublicOfferContent>
          13.3. The User must comply with conduct, safety and registration
          rules imposed by Suppliers and competent authorities and must arrive
          at the place of Service in sufficient time.
        </PublicOfferContent>

        <PublicOfferContent>
          13.4. If a problem arises during travel, the User must notify the
          Company or the Supplier named in the travel documents without undue
          delay and provide a reasonable opportunity to remedy the issue.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>
          14. Payment Disputes and Fraud Prevention
        </PublicOfferInfoTitle>

        <PublicOfferContent>
          14.1. Before disputing a card transaction, the User is encouraged to
          contact the Company so that the Order can be checked and the matter
          may be resolved. This does not restrict the User's lawful rights
          against a bank or payment system.
        </PublicOfferContent>

        <PublicOfferContent>
          14.2. Knowingly disputing a lawfully supplied Service without valid
          grounds, using another person's payment details, or providing forged
          documents may result in Order cancellation, access restrictions and
          disclosure to competent authorities where permitted by law.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>
          15. Personal Data and Electronic Communications
        </PublicOfferInfoTitle>

        <PublicOfferContent>
          15.1. The Company processes personal data in accordance with the
          Privacy Policy published on the Website. To fulfil an Order, data may
          be shared with Suppliers, payment organisations and public
          authorities, including outside the User's country of residence, where
          necessary and lawful.
        </PublicOfferContent>

        <PublicOfferContent>
          15.2. The User agrees to receive service communications about an
          Order by email, telephone, SMS, messenger or through the personal
          account area. Such communications are not marketing where they are
          necessary to perform the Order.
        </PublicOfferContent>

        <PublicOfferContent>
          15.3. Marketing communications are sent where the required consent has
          been obtained. The User may opt out using an available method without
          opting out of necessary communications about active Orders.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>
          16. Intellectual Property and Use of the Website
        </PublicOfferInfoTitle>

        <PublicOfferContent>
          16.1. The Website's text, design, software elements, databases, trade
          identifiers and other materials belong to the Company or are used by
          it on a lawful basis.
        </PublicOfferContent>

        <PublicOfferContent>
          16.2. The User may use Website materials only for personal,
          non-commercial purposes unless otherwise authorised in writing by the
          Company or the rights holder.
        </PublicOfferContent>

        <PublicOfferContent>
          16.3. Copying materials for publication is permitted only to the
          extent allowed by law, with copyright notices preserved and an active
          link to{" "}
          <a href="https://www.flyashgabat.com" target="_blank" rel="noreferrer">
            https://www.flyashgabat.com
          </a>
          . No publication may imply a partnership with or endorsement by the
          Company without its written consent.
        </PublicOfferContent>

        <PublicOfferContent>
          16.4. Links to third-party websites are provided for convenience. The
          Company does not control such websites and is not responsible for
          their content, security or data-processing practices.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>17. Liability</PublicOfferInfoTitle>

        <PublicOfferContent>
          17.1. The Company is responsible for a breach of its own obligations
          to the extent provided by this Offer and applicable law. Nothing in
          this Offer excludes or limits any liability that cannot lawfully be
          excluded or limited.
        </PublicOfferContent>

        <PublicOfferContent>
          17.2. The Company is not responsible for the acts or decisions of an
          independent Supplier, a public authority or another third party
          unless responsibility is imposed on the Company by law or by the
          terms of the relevant Order.
        </PublicOfferContent>

        <PublicOfferContent>
          17.3. The Company is not responsible for loss caused by incorrect
          User information, missing documents, late arrival, a no-show, breach
          of Supplier rules, refusal of entry or other circumstances within the
          User's control.
        </PublicOfferContent>

        <PublicOfferContent>
          17.4. Information on schedules, availability, fares and Service
          features is supplied by Suppliers and may change. The Company takes
          reasonable steps to display information correctly and correct known
          errors but cannot guarantee the uninterrupted operation of external
          systems.
        </PublicOfferContent>

        <PublicOfferContent>
          17.5. Where liability may lawfully be limited, compensation is
          limited to documented direct loss causally connected to the Company's
          breach. This restriction does not apply to intentional misconduct,
          gross negligence, death or personal injury, or any other case in which
          limitation is prohibited by law.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>18. Force Majeure</PublicOfferInfoTitle>

        <PublicOfferContent>
          18.1. A party is not liable for a failure caused by extraordinary and
          unavoidable circumstances beyond its reasonable control, including
          natural disasters, epidemics, war, civil unrest, strikes, border or
          airspace closures, government action, and major failures of
          communications or payment infrastructure.
        </PublicOfferContent>

        <PublicOfferContent>
          18.2. A party affected by such circumstances must, where possible,
          notify the other party promptly and take reasonable steps to reduce
          the consequences.
        </PublicOfferContent>

        <PublicOfferContent>
          18.3. If a travel programme is cancelled or materially disrupted by
          force majeure, mandatory law, Supplier terms and the refund rules for
          Services not actually provided will apply.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>
          19. Governing Law and Dispute Resolution
        </PublicOfferInfoTitle>

        <PublicOfferContent>
          19.1. This Offer is governed by the laws of Turkmenistan, including
          the Civil Code of Turkmenistan. This choice of law does not deprive a
          consumer of mandatory protection under the law of the country of
          their habitual residence where that protection applies and cannot be
          waived by agreement.
        </PublicOfferContent>

        <PublicOfferContent>
          19.2. Before commencing court proceedings, the parties will seek to
          resolve a dispute through negotiation. A complaint should be sent to{" "}
          <a href="mailto:info@flyashgabat.com">info@flyashgabat.com</a> and
          include the Order number, a description of the claim and supporting
          documents.
        </PublicOfferContent>

        <PublicOfferContent>
          19.3. The Company considers a complaint and responds within the
          period required by applicable law or, where no period is prescribed,
          within 15 business days after receiving sufficient information.
        </PublicOfferContent>

        <PublicOfferContent>
          19.4. An unresolved dispute will be heard by a competent court in
          accordance with applicable jurisdiction rules. The consumer's rights
          to contact competent authorities and use mandatory redress mechanisms
          remain unaffected.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>
          20. Amendments to this Offer
        </PublicOfferInfoTitle>

        <PublicOfferContent>
          20.1. The Company may amend this Offer by publishing a new version on
          the Website and stating its effective date.
        </PublicOfferContent>

        <PublicOfferContent>
          20.2. A new version applies to Orders placed after it takes effect.
          An Order confirmed earlier remains governed by the version in force
          when it was placed unless a change is required by law or agreed by
          the parties.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>
          21. Company Details and Contact Information
        </PublicOfferInfoTitle>

        <PublicOfferContent>
          <strong>Full legal name</strong>
        </PublicOfferContent>

        <PublicOfferContent>
          Individual Enterprise "Jahankeshde Hyzmat"
        </PublicOfferContent>

        <PublicOfferContent>
          <strong>English name</strong>
        </PublicOfferContent>

        <PublicOfferContent>Jahankeshde Hyzmat P.E.</PublicOfferContent>

        <PublicOfferContent>
          <strong>Country of registration</strong>
        </PublicOfferContent>

        <PublicOfferContent>Turkmenistan</PublicOfferContent>

        <PublicOfferContent>
          <strong>Registration number</strong>
        </PublicOfferContent>

        <PublicOfferContent>26010586</PublicOfferContent>

        <PublicOfferContent>
          <strong>Taxpayer number</strong>
        </PublicOfferContent>

        <PublicOfferContent>601211001447</PublicOfferContent>

        <PublicOfferContent>
          <strong>Licence/permit</strong>
        </PublicOfferContent>

        <PublicOfferContent>6-17-27-162</PublicOfferContent>

        <PublicOfferContent>
          <strong>Registered address</strong>
        </PublicOfferContent>

        <PublicOfferContent>
          Gorkut-Ata 5A, Mary city, Turkmenistan
        </PublicOfferContent>

        <PublicOfferContent>
          <strong>Business address</strong>
        </PublicOfferContent>

        <PublicOfferContent>
          Gorkut-Ata 5A, Mary city, Turkmenistan
        </PublicOfferContent>

        <PublicOfferContent>
          <strong>Telephone</strong>
        </PublicOfferContent>

        <PublicOfferContent>
          +993 522 4-55-44
          <br />
          +993 61 82 63 45
        </PublicOfferContent>

        <PublicOfferContent>
          <strong>Email</strong>
        </PublicOfferContent>

        <PublicOfferContent>
          <a href="mailto:info@flyashgabat.com">
            info@flyashgabat.com
          </a>
        </PublicOfferContent>

        <PublicOfferContent>
          <strong>Website</strong>
        </PublicOfferContent>

        <PublicOfferContent>
          <a href="https://www.flyashgabat.com" target="_blank" rel="noreferrer">
            https://www.flyashgabat.com
          </a>
        </PublicOfferContent>

        <PublicOfferContent>
         
        </PublicOfferContent>
      </PublicOfferInfo>
    </Wrapper>
  );
};